import { Box } from "@mui/material";
import React from "react";
import { NoteBlockContainer } from "./note";

export const StaticHtmlBlock: React.FC<{
  html: string;
  name?: string;
}> = ({ html, name }) => (
  <NoteBlockContainer name={name ?? ""}>
    <Box dangerouslySetInnerHTML={{ __html: html }} />
  </NoteBlockContainer>
);
